import React from "react"
import Layout from "../components/layout/Layout"
import Nav from "../components/layout/Nav"
import Seo from "../components/Seo"
import CaruselThumbnails from "../components/storiesPage/CaruselThumbnails"
import EduBottomBanner from "../components/storiesPage/EduBottomBanner"
import EduTopBanner from "../components/storiesPage/EduTopBanner"

const price = () => {
    return (
        <>
            <Seo title="Приче" />
            <Layout>
                <Nav bgNav />
                <EduTopBanner />
                <CaruselThumbnails />
                <EduBottomBanner />
            </Layout>
        </>
    )
}

export default price
